import React from 'react';
import {Badge, Button, Col, Row} from "reactstrap";
import {getStats} from "../../components/helpers/StatsHelpers";
import {RiBookLine, RiBookOpenFill, RiBookOpenLine, RiCloudy2Line, RiSpeakFill, RiSpeakLine} from "react-icons/ri";
import {RiBookShelfLine} from "@remixicon/react";

class StatsOverviewWithSongBook extends React.Component {
    state = {
        stats: [],
        chosenSongBooksButtons: null,
    }

    constructor(props) {
        super(props);
        getStats.call(this);
    }

    componentDidMount() {
        const songBooks = sessionStorage.getItem("selected-song-books") == null ? [] : JSON.parse(sessionStorage.getItem("selected-song-books"));
        const preferredSongBooks = sessionStorage.getItem("preferred-song-books") == null ? [] : JSON.parse(sessionStorage.getItem("preferred-song-books"));
        this.setState({
            chosenSongBooksButtons: [...songBooks,...preferredSongBooks]
                .sort((sb1,sb2) => sb1.title > sb2.title? 1 : -1)
                .map((theme, index) => {
                    return this.showPill(theme);
                })
        })
    }

    removeBook = (id) => {
        let updateSongBooks = sessionStorage.getItem("selected-song-books") == null ? null : JSON.parse(sessionStorage.getItem("selected-song-books")).filter(sb => sb.id !== id);
        if (updateSongBooks == null) {
            sessionStorage.removeItem("selected-song-books");
        } else {
            sessionStorage.setItem("selected-song-books", JSON.stringify(updateSongBooks));
        }

        this.componentDidMount();
        this.forceUpdate();
        // this.props.enableActiveButtonHandler(true);
    }

    showPill = songBook => {
        return (
            <div className="col-md-3 col-xs-12 flex-wrap">
                {/*<Button className='text-uppercase mx-2 text-dark col-md-6 col-xs-12' outline color="primary">*/}
                <Button className='text-uppercase mx-2 col-md-12 col-xs-12' color="primary" size="sm" style={{margin: '4px', width: "95%"}}>
                    <span className="text-white">
                        {songBook.title.length <= 22 ? songBook.title : !songBook.shortTitle ? songBook.title.substring(0,19) + "..." : songBook.shortTitle}
                    </span>
                    {/*&nbsp;&nbsp;<a a href={this.removeBook(songBook.id)}><RiDeleteBinLine color="white" size="16"/></a>*/}
                </Button>
            </div>
        );
    }

    render() {
        // const selectedSongTitle = !this.state.chosenSongBooksButtons || this.state.chosenSongBooksButtons.length === 0 ? "No song books selected" : "Select song books";
        const pillsToBeShown = window.location.pathname.includes("choose-song-book") || window.location.pathname.includes("lectionary") ? "" : this.state.chosenSongBooksButtons;

        return (
            <div>
                <div className="col-md-12 col-xs-12 card-profile-stats d-flex justify-content-center row">
                    <div className="col-md-3 col-xs-12 flex-wrap">
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : <RiBookOpenLine color="#5e72e4"/>}</span>
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books")?.title + ":"}</span>
                        <span className="stats-description">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books")?.value}</span>
                    </div>
                    <div className="col-md-3 col-xs-12 flex-wrap">
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : <RiSpeakLine color="#5e72e4"/>}</span>
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Songs")?.title + ":"}</span>
                        <span className="stats-description">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Songs")?.value}</span>
                    </div>
                    <div className="col-md-3 col-xs-12 flex-wrap">
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : <RiCloudy2Line color="#5e72e4"/>}</span>
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Themes")?.title + ":"}</span>
                        <span className="stats-description">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Themes")?.value}</span>
                    </div>
                </div>
                <div className="py-2 mt-lg-0 col-md-12 col-xs-12  card-profile-stats d-flex justify-content-center row" style={{width: "100%"}}>
                    {pillsToBeShown}
                </div>
            </div>
        )
    }
};

export default StatsOverviewWithSongBook;
